import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import React from 'react';
import { CourseIconKey } from '../../student/mockData';

export const courseIcons: Record<CourseIconKey, React.ElementType> = {
    book: MenuBookRoundedIcon,
    chat: ForumRoundedIcon,
    voice: RecordVoiceOverRoundedIcon,
};
